import React, { useEffect, useState } from 'react';
import failedIcon from '../../Images/Common/failure-icon.svg';
import './style.scss';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { message } from 'antd';
// import { projects } from '../../../../../shared-lib/src/config';

const baseUrl = 'https://api-nimbus.flixstock.com/';
const distributorId = '663b39b3ab4ec46c6ebcf259';
const token = localStorage.getItem('metamodel_token');

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const [details, setDetails] = useState(null);
  const [retryDetails, setRetryDetails] = useState(null);
  const navigate = useNavigate();

  const getFailedDetails = async () => {
    const purchaseInfo = searchParams.get('purchaseInfo');
    if (!purchaseInfo) return;

    try {
      const response = await axios.get(
        `${baseUrl}api/v1/pricing/checkout/info/${purchaseInfo}`,
        {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            distributorId,
          },
        }
      );
      setDetails(response?.data?.data);
    } catch (error) {
      message.error(error.message);
    }
  };

  const getPaymentDetails = async (piid, rcid, redirectby) => {
    if (!piid || !rcid) return;

    try {
      const response = await axios.get(
        `${baseUrl}api/v1/pricing/plan?priceInfoId=${piid}&rateCode=${rcid}`,
        {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            distributorId,
          },
        }
      );
      const plan = response?.data?.plan;
      setRetryDetails({
        ...plan,
        priceInfoId: piid,
        rateCode: rcid,
        redirectby,
      });
    } catch (error) {
      console.error('Error fetching payment details:', error);
    }
  };

  useEffect(() => {
    getFailedDetails();
  }, []);

  useEffect(() => {
    const txnMetadata = searchParams.get('txnMetadata');
    if (txnMetadata) {
      const metadata = JSON.parse(txnMetadata);
      getPaymentDetails(
        metadata?.priceInfoId,
        metadata?.rateCode,
        metadata?.redirectby
      );
    }
  }, [searchParams]);

  const handleRetry = () => {
    if (retryDetails) {
      const {
        amount,
        priceInfoId,
        rateCode,
        planType,
        currency,
        credits,
        redirectby,
      } = retryDetails;
      let urlToPayment = `/plan-details?rate=${amount}&piid=${priceInfoId}&rcid=${rateCode}&plan=${planType}&currency=${currencySymbol(
        currency
      )}&credits=${credits}`;

      if (redirectby) {
        urlToPayment += `&redirectby=${redirectby}`;
      }

      navigate(urlToPayment);
    } else {
      navigate('/subscription');
    }
  };

  const currencySymbol = (currency) => {
    switch (currency?.toLowerCase()) {
      case 'usd':
      case 'sgd':
        return '$';
      case 'inr':
        return '₹';
      default:
        return currency;
    }
  };

  const formatBillingHistoryDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}, ${date.toLocaleTimeString()}`;
  };

  return (
    <div className="payment_failure_details">
      <div className="failure_card">
        <img src={failedIcon} alt="Failure Icon" className="failure_icon" />
        <div className="payment_status">
          <h2 className="status_title">Payment Failed!</h2>
        </div>
        <div className="price">
          {currencySymbol(details?.plan?.currency)}
          {details?.plan?.value}
        </div>
        <div className="other_details">
          <div className="details_box">
            <div className="ref_number_wrapper">
              <div className="heading">Ref Number</div>
              <div className="number_value">
                {searchParams.get('purchaseInfo')}
              </div>
            </div>
            <div className="payment_time_wrapper">
              <div className="heading">Payment Time</div>
              <div className="number_value">
                {formatBillingHistoryDate(details?.createdAt)}
              </div>
            </div>
          </div>
          <div className="amount_details">
            <div className="amount_heading">Amount</div>
            <div className="amount_value">
              {currencySymbol(details?.plan?.currency)}
              {details?.plan?.value}
            </div>
          </div>
        </div>
        <button className="download_invoice" onClick={handleRetry}>
          Retry Payment
        </button>
        <Link to="/subscription" className="cancel_link">
          Cancel
        </Link>
      </div>
    </div>
  );
};

export default PaymentFailure;
